import React from "react";
import { Box } from "@mui/material";
import { FONT_SIZE } from "../../../constants/fontSizes";
import { SKILL_LEVEL_COLORS } from "../../../constants/colors";

/**
 * スキルレベルバッジ表示コンポーネント
 *
 * 表示内容：
 * - レベル文字（S / A / B / C / D）
 * - レベルに応じたグラデーション背景
 *
 * props:
 * - level: スキルレベル（"S"〜"D"）
 */
const SkillLevelBadge = ({ level }) => {
  const gradient = SKILL_LEVEL_COLORS[level];

  if (!gradient) return null;

  const outerGradient = `linear-gradient(45deg, ${gradient.outerStart} 0%, ${gradient.outerEnd} 100%)`;
  const innerGradient = `linear-gradient(45deg, ${gradient.innerStart} 0%, ${gradient.innerEnd} 100%)`;

  return (
    <Box
      sx={{
        width: 32,
        height: 32,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        // 外側リング（レベル別）
        background: outerGradient,
      }}
    >
      <Box
        sx={{
          width: 28,
          height: 28,
          borderRadius: "50%",

          // 内側バッジ（レベル別）
          background: innerGradient,

          color: "#fff",
          fontSize: { xs: FONT_SIZE.XS, sm: FONT_SIZE.SM },
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",

          // インナーシャドウ
          boxShadow: "inset 0 0 10px rgba(0,0,0,0.15)",
        }}
      >
        {level}
      </Box>
    </Box>
  );
};

export default SkillLevelBadge;
